module.exports = __webpack_public_path__ + "img/back_36.71e826c7.svg";